<div class="row">
    <div class="col-12">
        <div id="clientList" class="card">
            <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems"
                [listService]="requisitionListService" (buttonActionSelected)="buttonActionSelected($event)"
                (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
                (searchTermChanged)="requisitionListService.searchTerm = $event"
                (resetListLayout) = "resetList($event)"
                (paginationSelected)="paginationUpdated(requisitionListService,$event)" [serviceData]="serviceData"
                (pageSizeSelected)="requisitionListService.pageSize = $event"
                (searchTermFilterSelected)="searchTermFilterChanged($event)"
                ></app-list-layout>
        </div>
    </div>
</div>